

const SubsectionTitle = (props) => {
  
    return (
      <h4>{props.label}</h4>
    );
  }
  
  export default SubsectionTitle;